/* eslint-disable no-prototype-builtins */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { Button, InputLabel, TableContainer } from "@material-ui/core";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import { Grid } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CustomSelectNew from "components/UpdateUi/CustomeSelect";
import Table from "components/UpdateUi/Table/Table";
import { parseDate } from "utils/Utils";
import { textFormat } from "utils/Utils";
import CustomeDateCalender from "components/CustomDateSelector/DateSelector.js";
import ToastModal from "views/components/ToastModal";
import { loanApplicationStatus } from "assets/properties/properties";
import CustomDateField from "components/CustomDateSelector/CustomDateField";
import { parseAndSetFlag } from "utils/Utils";
import { useNavigate } from "react-router-dom";
import { colateralApprovalData } from "assets/properties/properties";
const style = () => ({
  selectContainer: {
    display: "block",
    "& .MuiFormControl-root": {
      "& .MuiInput-underline:before": {
        content: "inherit",
      },
      "& .MuiInput-underline.Mui-focused:after": {
        transform: "inherit",
        borderBottom: "inherit",
      },
      "& .MuiSelect-select.MuiSelect-select": {
        padding: "6px 10px",
        borderRadius: "5px",
        border: "1px solid gray",
        textAlign: "left",
      },
    },
  },
  dateSelector: {
    marginTop: "27px",
  },
  buttonContainer: {
    textAlign: "right",
    "@media (max-width:600px)": {
      textAlign: "center",
    },
  },
  nextButton: {
    padding: "0px 40px",
    letterSpacing: "1px",
  },
  nextButton1: {
    padding: "0px 40px",
  },
});
const CollateralDecision = ({
  setNext,
  setBack,
  loanApplicationId,
  loanApplicationNumber,
  editable,
  status,
  classes,
  mandatory,
  level,
  featureFlags,
  collaterDiscId,
}) => {
  const navigate = useNavigate();
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [decision, setDecision] = useState("");
  const [decisionState, setDecisionState] = useState(false);
  const [remarks, setRemarks] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const isValidated = () => {
    if (decision === "") {
      setDecisionState(true);
    } else {
      setDecisionState(false);
    }

    if (decision && decision !== "") {
      return true;
    } else {
      return false;
    }
  };
  const handlecreateuserSubmit = async (event) => {
    if (decision === "" || typeof decision === "undefined") {
      setDecisionState(true);
    }
    if (status === colateralApprovalData?.statusCode) {
      if (isValidated()) {
        //DECISION_ADD
        setCallInProgress(true);
        const res = await apiHandler({
          url: endpoint.COLLATERAL_APPROVAL_UPDATE_STATUS,
          method: "POST",
          authToken: authToken,
          data: {
            id: collaterDiscId,
            status: decision,
            remarks: remarks,
          },
        });
        setCallInProgress(false);
        if (res?.data?.error_code) {
          toastUpdate("Error", res?.data?.user_description, true);
          return;
        } else {
          if (decision === loanApplicationStatus.rejected) {
              UnAssignPacketNumber(decision);
          }else if(decision === loanApplicationStatus?.approved){
            handleCloseModal(loanApplicationStatus?.approved);
          }else{
            handleCloseModal(decision);
          }
        }
      }
    }
  };
  
  const UnAssignPacketNumber = async (decision) => {
    const res = await apiHandler({
      url: endpoint.UNASSIGN_PACKETS,
      method: "POST",
      authToken: authToken,
      data: {
        loanApplicationId: loanApplicationId,
      },
    });
    if (res?.data) {
      handleCloseModal(decision);
    }
  };
  // cancel button function
  const handlecanceluser = () => {
    setBack();
    //props.history.go(-1);
  };
  const handlenext = () => {
    setNext();
  };
  const back = () => {
    setBack();
  };
  const handleCloseModal = (type) => {
      navigate("/loanservice/collateralApproval", { state: { from: '' } });
  }
  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader label="Collateral Approval" />
      </Grid>
      <Grid item xs={12} sm={12} md={12} className={classes.inputContainer}>
        <Grid container className={classes.inputFieldContainer}>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <CustomSelectNew
              label="Decision*"
              error={decisionState}
              value={decision || ""}
              setState={setDecision}
              data={colateralApprovalData?.decisionList}
              disabled={!editable}
              setError={setDecisionState}
              id="decision"
              type="type"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={4} className={classes.fieldContaienr}>
            <textarea
              placeholder="Remarks"
              onChange={(e) => (editable ? setRemarks(e.target.value) : null)}
              value={textFormat(remarks)}
              disabled={!editable}
              required
              id="remarks"
              style={{ width: "100%", borderRadius: "5px" }}
            />
          </Grid>
          {status === colateralApprovalData?.statusCode ? (
            <GridContainer style={{ flexDirection: "row" }}>
              <GridItem
                xs={12}
                sm={12}
                md={12}
                lg={12}
                className={classes.buttonContainer}
                style={{
                  textAlign: window.innerWidth <= 600 ? "center" : "right",
                }}
              >
                <Button
                  size="small"
                  onClick={() => handlecanceluser()}
                  className={classes.nextButton1}
                >
                  Back
                </Button>
                <Button
                  size="small"
                  className={classes.nextButton}
                  disabled={callInProgress}
                  onClick={(event) => {
                    handlecreateuserSubmit(event);
                  }}
                >
                 Submit
                </Button>
              </GridItem>
            </GridContainer>
          ) : (
            <GridContainer>
              <GridItem
                xs={12}
                sm={12}
                md={12}
                className={classes.buttonContainer}
                style={{
                  textAlign: window.innerWidth <= 600 ? "center" : "right",
                }}
              >
                <Button
                  style={{ margin: "5px" }}
                  size="small"
                  className={classes.nextButton1}
                  onClick={() => back()}
                >
                  Back
                </Button>
                <Button
                  style={{ margin: "5px" }}
                  size="small"
                  className={classes.nextButton}
                  onClick={() =>
                    status === "REJECTED" ? handleCloseModal() : handlenext()
                  }
                >
                  {status === "REJECTED" ? "Close" : "Next"}
                </Button>
              </GridItem>
            </GridContainer>
          )}
          {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
          {callInProgress && (
            <CircularProgresss callInProgress={callInProgress} />
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

CollateralDecision.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
  loanApplicationId: PropTypes.object,
  editable: PropTypes.object,
  closeModal: PropTypes.func,
  loanApplicationNumber: PropTypes.object,
  status: PropTypes.object,
};

export default withStyles(style)(CollateralDecision);
